import React from 'react';
import '../styles.css';

function ProfileDetails(props) {
    return (
        <div className='column' style={{textAlign: 'center'}}>
            <b className='titleText' style={{ marginTop: 50 }}>Welcome, {props.identification.name}</b>
            <p className='titleText' style={{fontSize: 24}}><b>Username:</b> {props.identification.username}</p>
            <p className='titleText' style={{fontSize: 24}}><b>School Code:</b> {props.identification.schoolcode}</p>
            <p className='titleText' style={{fontSize: 24}}><b>Class Code:</b> {props.identification.classcode}</p>
            <p className='titleText' style={{fontSize: 24}}><b>Email:</b> {props.identification.email}</p>
        </div>
    )
}

export default ProfileDetails;